export interface SampleData {
    barcode: string;
    containerBarcode: string;
    containerReceiptDate: string;
    expectedReceiptCondition: string;
    actualReceiptCondition: string;
    specimenType: string;
    aliquotedDate: string;
    containerLabelLine1: string;
    containerLabelLine2: string;
    currentSampleStatus: SampleStatus;
    sampleRegisteredDate: string;
    smartSpecimenClass: string;
    smartSpecimenClassDescription: string;
    cancellationReason: string;
    pendingDaysReceipt: string;
    notification1SentDate: Date;
    notification1SentTo: string;
    notification2SentDate: Date;
    notification2SentTo: string;
    notification3SentDate: Date;
    notification3SentTo: string;
    parentAliquotDate?: Date;
    childAliquotDate?: Date;
}

export interface SampleHeader {
    displayText: string;
    key: string;
    isDate?: boolean;
    isDateTime?: boolean;
}


export interface SampleDetails {
    data: SampleData;
    header: SampleHeader[];
}

export enum SampleStatus {
    InInventory = 'In Inventory',
    Shipped = 'Shipped',
    Discarded = 'Discarded',
    Received = 'Received',
    NotReceived = 'Not Received',
    Cancelled = 'Cancelled',
    NA = ''
}